import { render } from "./BenefitsList.vue?vue&type=template&id=5bdca81b&ts=true"
import script from "./BenefitsList.vue?vue&type=script&lang=ts"
export * from "./BenefitsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__